import { ReactElement } from 'react';

import { CrossSvg, FileSvg } from '@cashier/cashier-assets';

import { FileName } from '../fileName';

import styles from './styles.module.scss';

type FilesListProperties = {
  files: File[];
  onFileRemove: (file: File) => void;
};

export const FileList = ({
  files,
  onFileRemove,
}: FilesListProperties): ReactElement => {
  const bytesToReadable = (bytes: number, decimals = 2): string => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${Number.parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))} ${sizes[i]}`;
  };

  return (
    <ul className={styles.filesList}>
      {files.map((file) => (
        <li key={file.name} className={styles.fileItem}>
          <FileSvg />
          <FileName name={file.name} />
          <div className={styles.fileSize}>
            {bytesToReadable(file.size)}
            <button
              onClick={() => onFileRemove(file)}
              className={styles.deleteFile}
            >
              <CrossSvg />
            </button>
          </div>
        </li>
      ))}
    </ul>
  );
};
